export enum WinnerPayoutStatusTypes {
  NotPaid = 1,
  Paid = 2,
  Forfeited = 3,
  Expired = 4
}
